import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';

const DVSADisclaimer = () => {
  return (
    <div className="bg-amber-50 border-l-4 border-amber-500 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertCircle className="w-6 h-6 text-amber-600" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Important Notice: Third-Party Service
            </h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We are a third-party booking assistance service. We are <strong>not affiliated with or connected to the DVSA</strong> (Driver and Vehicle Standards Agency) or any government agency. 
            </p>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You can also book your test directly through the official DVSA website at no additional cost. Our service provides convenience, assistance, and additional support for a fee.
            </p>
            <a
              href="https://www.gov.uk/book-driving-test"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-blue-900 hover:text-blue-700 font-medium transition-colors"
            >
              <span>Visit Official DVSA Website</span>
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DVSADisclaimer;